export default {
  landing: {
    hero: {
      tag: "Bewerbungen geöffnet",
      title: "Finden Sie Ihre Ausbildung im dualen System",
    },
    error:
      "Die Seite konnte nicht geladen werden. Überprüfen Sie den erhaltenen Link oder versuchen Sie es später erneut.",
    retry: "Erneut versuchen",
    sections: {
      contact: {
        title: "Ihre Kontaktdaten",
        first_name: "Vorname",
        last_name: "Nachname",
        email: "E-Mail-Adresse",
        phone: "Telefonnummer",
        last_degree: "Letzter erworbener Abschluss",
        last_school: "Letzte besuchte Schule",
        optional: "(optional)",
        required_indicator: "Pflichtfeld",
        required_error: "Dieses Feld ist erforderlich.",
        email_error: "Diese E-Mail-Adresse ist ungültig. Erwartetes Format: name@beispiel.de",
      },
      training: {
        title: "Unsere Ausbildungen",
        more_info: "Mehr Informationen",
        modal: {
          close: "Schließen",
          brochure: "Broschüre herunterladen",
          select: "Diese Ausbildung wählen",
          selected: "Ausbildung ausgewählt",
        },
      },
      project: {
        preselected_note:
          "Sie kommen für „{name}“, bereits unten ausgewählt. Andere ähnliche Ausbildungen könnten Sie auch interessieren.",
      },
      origin: {
        title: "Wie haben Sie von uns erfahren?",
      },
      consent: {
        aria_label: "Einwilligung",
        text: "Ich akzeptiere die allgemeinen Geschäftsbedingungen und die Datenschutzrichtlinie. Eine Abmeldung ist jederzeit möglich.",
        privacy_policy_link: "Datenschutzrichtlinie",
        required_error: "Bitte akzeptieren Sie die Bedingungen, um fortzufahren.",
        captcha_label: "Anti-Robot-Prüfung",
      },
    },
    final: {
      info_button: "Informationen erhalten",
      apply_button: "Bewerben",
      rgpd_note: "Ihre Daten werden gemäß der DSGVO verarbeitet.",
      privacy_policy_link: "Datenschutzrichtlinie",
      privacy_policy_title: "Datenschutzrichtlinie",
      info_success: "Vielen Dank! Wir senden Ihnen in Kürze weitere Informationen.",
      info_sent_title: "Vielen Dank für Ihr Interesse!",
      info_sent_text:
        "Ihre Anfrage wurde übermittelt. Das Team des Ausbildungszentrums sendet Ihnen Informationen zu der Ausbildung, die Sie interessiert.",
      info_sent_resume_title: "Möchten Sie sich bewerben?",
      info_sent_resume_text:
        "Wir haben Ihnen gerade eine E-Mail an {email} gesendet. Sie enthält einen Link, um Ihre Bewerbung jederzeit fortzusetzen, ohne Ihre Angaben erneut eingeben zu müssen.",
      info_sent_spam_note: "Sie finden die E-Mail nicht? Schauen Sie auch in Ihrem Spam-Ordner nach.",
      already_registered: "Ihre Akte existiert bereits — wir melden uns bei Bedarf.",
    },
  },
  // TA-4768/4769: Top-Level-Schlüssel (nicht unter "landing") - jeder $t("candidacyGroups...")-Aufruf
  // im Code (CandidacyGroupsView/CandidacyFormationGroupsComponent/LandingGroupRankBadgeComponent)
  // verwendet diesen Pfad ohne "landing."-Präfix.
  candidacyGroups: {
    hero: {
      tag: "Ihre Bewerbung",
      title: "Eine Gruppe wählen",
      title_success: "Vielen Dank!",
    },
    intro:
      "Sie haben Interesse an einer oder mehreren der folgenden Ausbildungen gezeigt. Wählen Sie für jede die Gruppe(n) aus, für die Sie sich bewerben möchten, und ordnen Sie sie nach Ihrer Präferenz.",
    loading: "Ihre Ausbildungen werden geladen…",
    error:
      "Ihre Ausbildungen konnten nicht geladen werden. Prüfen Sie den erhaltenen Link oder versuchen Sie es später erneut.",
    empty: "Keine Ausbildung zum Anzeigen.",
    no_groups_title: "Noch keine Bewerbung geöffnet",
    no_groups_sub: "Das CFA informiert Sie, sobald die Bewerbungen für diese Ausbildung geöffnet werden.",
    entry_year: "{year}. Jahr",
    start_date: "Beginn: {date}",
    rank: {
      selected: "Wahl Nr. {rank}",
      locked: "Gruppe nicht auswählbar",
    },
    move_up: "{name} in der Reihenfolge nach oben verschieben",
    move_down: "{name} in der Reihenfolge nach unten verschieben",
    max_choices_reached: "Sie können maximal {max} Gruppen auswählen.",
    validate_button: "Meine Bewerbung bestätigen",
    confirm_title: "Ihre Bewerbung bestätigen?",
    confirm_text:
      "Ihre Auswahl wird an das CFA übermittelt und Sie erhalten eine E-Mail zur Aktivierung Ihres Kontos. Sie können Ihre Rangfolge danach noch ändern.",
    confirm_button: "Bestätigen",
    success: "Bewerbung übermittelt! Sie erhalten eine E-Mail zur Aktivierung Ihres Kontos.",
    success_title: "Ihre Bewerbungsakte wurde erstellt",
    success_text:
      "Noch ein Schritt: <strong>bestätigen Sie Ihre E-Mail-Adresse</strong>. Diese Prüfung stellt sicher, dass Sie es wirklich sind und Sie alle Informationen zu Ihrer Bewerbung erhalten.",
    success_box_title: "Prüfen Sie jetzt Ihre E-Mails",
    success_step1: "Öffnen Sie die E-Mail, die wir Ihnen gerade gesendet haben.",
    success_step2: "Klicken Sie auf den Bestätigungslink: Ihr Bewerberbereich öffnet sich.",
    success_step3: "Vervollständigen Sie Ihre Akte und laden Sie Ihre Unterlagen hoch.",
    success_note:
      "Sie finden die E-Mail nicht? Schauen Sie in Ihrem Spam-Ordner nach. Ihre Bewerbung wird erst geprüft, sobald Ihre Akte vollständig ist.",
  },
  secureData: {
    hero: {
      tag: "Ihre Daten sind sicher",
      title: "Fortsetzen oder neu beginnen",
    },
    intro:
      "Wir haben Ihre Anfrage sicher aufbewahrt. Wählen Sie, wie Sie fortfahren möchten: setzen Sie fort, wo Sie aufgehört haben, oder geben Sie Ihre Daten erneut ein.",
    resume_title: "Fortsetzen, wo ich aufgehört habe",
    resume_sub: "Erhalten Sie einen einmaligen Link per E-Mail zu Ihrem vorausgefüllten Formular.",
    restart_title: "Meine Daten erneut eingeben",
    loading: "Ihr Link wird geprüft…",
    error:
      "Diese Seite konnte nicht geöffnet werden. Prüfen Sie den erhaltenen Link oder versuchen Sie es später erneut.",
    mail_sent: "E-Mail gesendet! Prüfen Sie Ihr Postfach, um fortzufahren.",
    resume_ok: "Hallo {name}, Ihre Anfrage ist bereit zur Fortsetzung.",
    resume_continue: "Weiter zu meiner Bewerbung",
    prefill_choice: "Wählen Sie, wie es weitergeht:",
    resume_expired: "Dieser Link ist abgelaufen oder wurde bereits verwendet. Fordern Sie unten einen neuen an.",
    resend_link: "Neuen Link erhalten",
    restart_intro: "Ihre neuen Daten ersetzen die Ihrer bestehenden Bewerbung.",
    restart_submit: "Meine Daten bestätigen",
    restart_error: "Prüfen Sie Ihre Daten: Die E-Mail muss mit Ihrer ursprünglichen Anfrage übereinstimmen.",
    restart_ok: "Daten aktualisiert!",
  },
  unsubscribe: {
    hero: {
      tag: "Unsere Nachrichten nicht mehr erhalten",
      title: "Abmelden",
    },
    intro:
      "Sie können sich mit einem Klick abmelden. Wenn Sie möchten, nennen Sie uns unten Ihren Grund — er hilft uns, unsere Kommunikation zu verbessern.",
    reasons_label: "Abmeldegrund",
    error:
      "Diese Seite konnte nicht geöffnet werden. Prüfen Sie den erhaltenen Link oder versuchen Sie es später erneut.",
    submit: "Abmeldung bestätigen",
    submit_error: "Ihre Abmeldung konnte nicht gespeichert werden. Versuchen Sie es später erneut.",
    optional_note: "Sie können auch ohne Auswahl eines Grundes bestätigen.",
    done: "Notiert, Sie erhalten keine weiteren Nachrichten von uns.",
    reasons: {
      admitted_elsewhere: {
        title: "Anderswo zugelassen",
        sub: "Sie haben eine Ausbildung an einer anderen Einrichtung gefunden.",
      },
      not_interested: { title: "Nicht mehr interessiert", sub: "Dieser Weg passt nicht mehr zu Ihren Plänen." },
      not_the_requester: { title: "Anfrage nicht von mir", sub: "Sie haben diese Informationsanfrage nicht gestellt." },
      other: { title: "Andere", sub: "Ein anderer Grund als die oben genannten." },
    },
  },
};
